var DayWeatherPortraitComponent = /** @class */ (function () {
    function DayWeatherPortraitComponent() {
        this.shortTemperatureFormat = false;
    }
    return DayWeatherPortraitComponent;
}());
export { DayWeatherPortraitComponent };
